/* eslint-disable */
export const Colors = {
  baseBrand50: "#f0e8f7",
  baseBrand100: "#E9E0F5",
  baseBrand200: "#BDA4E2",
  baseBrand300: "#9C77D4",
  baseBrand400: "#7B49C5",
  baseBrand500: "#5A1CB7",
  baseBrand600: "#481692",
  baseBrand700: "#3f157f",
  baseBrand800: "#300f61",
  baseBrand900: "#1a0835",
  baseSteel50: "#E5E3E8",
  baseSteel100: "#DAD7DE",
  baseSteel200: "#CAC7D0",
  baseSteel300: "#B3AFBB",
  baseSteel400: "#7E788B",
  baseSteel500: "#5D566C",
  baseSteel600: "#4D465A",
  baseSteel700: "#3A3543",
  baseSteel800: "#28242E",
  baseSteel900: "#141217",
  baseGray50: "#FCFCFD",
  baseGray100: "#FBFBFC",
  baseGray200: "#FAF9FB",
  baseGray300: "#f6f5fa",
  baseGray400: "#F1EEF6",
  baseGray500: "#ECE8F3",
  baseGray600: "#DCD8E4",
  baseGray700: "#C4BCC8",
  baseGray800: "#A9A2B3",
  baseGray900: "#8A8198",
  baseBlue50: "#F1F6FD",
  baseBlue100: "#E1ECFE",
  baseBlue200: "#BED9FD",
  baseBlue300: "#72A5EE",
  baseBlue400: "#3881E7",
  baseBlue500: "#0661E1",
  baseBlue600: "#0551BD",
  baseBlue700: "#044095",
  baseBlue800: "#032D68",
  baseBlue900: "#021E46",
  baseGreen50: "#F4FBF8",
  baseGreen100: "#d5fbe2",
  baseGreen200: "#C3EAD7",
  baseGreen300: "#75C7A1",
  baseGreen400: "#36B579",
  baseGreen500: "#00a357",
  baseGreen600: "#008546",
  baseGreen700: "#006B39",
  baseGreen800: "#00522B",
  baseGreen900: "#00381E",
  baseRed50: "#fce9ea",
  baseRed100: "#FAE0E3",
  baseRed200: "#F4C7CC",
  baseRed300: "#E87D88",
  baseRed400: "#DD4151",
  baseRed500: "#D10015",
  baseRed600: "#B20012",
  baseRed700: "#8F000E",
  baseRed800: "#66000A",
  baseRed900: "#420007",
  baseYellow50: "#FDF7F2",
  baseYellow100: "#FFEDDB",
  baseYellow200: "#FFDDBD",
  baseYellow300: "#EBAE75",
  baseYellow400: "#E18733",
  baseYellow500: "#DA6900",
  baseYellow600: "#B85800",
  baseYellow700: "#944700",
  baseYellow800: "#6B3400",
  baseYellow900: "#3d1e00",
  baseMagenta50: "#FEFBFD",
  baseMagenta100: "#FCEBF4",
  baseMagenta200: "#F6CBE0",
  baseMagenta300: "#F0A8CC",
  baseMagenta400: "#E566A5",
  baseMagenta500: "#D91C7A",
  baseMagenta600: "#b61666",
  baseMagenta700: "#8c124f",
  baseMagenta800: "#640c38",
  baseMagenta900: "#430925",
  interactivePrimaryDefault: "#5A1CB7",
  interactivePrimaryActive: "#5A1CB7",
  interactivePrimaryHover: "#481692",
  interactivePrimaryPressed: "#3f157f",
  interactivePrimaryDisabled: "#9C77D4",
  interactiveSuccessDefault: "#00a357",
  interactiveSuccessHover: "#008546",
  interactiveSuccessPressed: "#006B39",
  interactiveSuccessActive: "#006B39",
  interactiveSuccessDisabled: "#75C7A1",
  interactiveWarningDefault: "#DA6900",
  interactiveWarningHover: "#B85800",
  interactiveWarningPressed: "#944700",
  interactiveWarningDisabled: "#EBAE75",
  interactiveCriticalDefault: "#D10015",
  interactiveCriticalHover: "#B20012",
  interactiveCriticalPressed: "#8F000E",
  interactiveCriticalDisabled: "#E87D88",
  interactiveInfoDefault: "#0661E1",
  interactiveInfoHover: "#0551BD",
  interactiveInfoPressed: "#044095",
  interactiveInfoDisabled: "#72A5EE",
  interactiveNeutralDefault: "#F1EEF6",
  interactiveNeutralHover: "#ECE8F3",
  interactiveNeutralPressed: "#DCD8E4",
  interactiveNeutralDisabled: "#C4BCC8",
  backgroundViewDarker: "#E5E3E8",
  backgroundViewHoverBackground: "#f0e8f7",
  backgroundViewLighter: "#FBFBFC",
  backgroundViewLight: "#FAF9FB",
  backgroundViewApp: "#f6f5fa",
  backgroundViewHover: "#F1EEF6",
  backgroundViewNavi: "#ECE8F3",
  backgroundViewEdit: "#F5F0FA",
  backgroundViewAppshell: "#FAF9FC",
  backgroundSystemInfoLight: "#e8f5fc",
  backgroundSystemInfoDefault: "#E1ECFE",
  backgroundSystemCritcal: "#FAE0E3",
  backgroundSystemWarning: "#FFEDDB",
  backgroundSystemSuccess: "#d5fbe2",
  backgroundPrivateDefault: "#FFF8D1",
  backgroundPrivateLight: "#FFFBE5",
  backgroundPrivateDark: "#EAE2B8",
  backgroundGradientBrand: "linear-gradient(270deg, #1999E3 0%, #102F7A 100%)",
  backgroundGradientGrowDefault: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
  backgroundGradientNeutral: "linear-gradient(180deg, #FFFFFF 0%, #F5F8F9 100%)",
  backgroundGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  backgroundGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  backgroundGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  backgroundGradientPurple: "linear-gradient(-90deg, #ca8bdb 30%, #7148bd 70%)",
  backgroundGradientOrange: "linear-gradient(90deg, #de6603 27.46%, #f4bb26 100%)",
  backgroundGradientRed: "linear-gradient(90deg, #FA2D4C 27.46%, #FFDBD4 100%)",
  backgroundGradientLightBlue: "linear-gradient(45deg, #1999E3 0%, #7cccfa 100%)",
  backgroundGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  backgroundGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  backgroundGradientFindTimeGray: "repeating-linear-gradient(135deg, #E8EDF1, #E8EDF1 6px, #C7D0D7 6px, #C7D0D7 12px)",
  backgroundGradientFindTimeBlue: "repeating-linear-gradient(135deg, #E9E0F5, #E9E0F5 6px, #BDA4E2 6px, #BDA4E2 12px)",
  backgroundGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  backgroundGradientMask: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%",
  backgroundGradientRainbow: "linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)",
  backgroundGradientGrayToTransparent: "linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)",
  backgroundGradientTellentDefault: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  backgroundGradientTellentPink: "linear-gradient(90deg, #5A1CB7 0%, #D91C7A 100%)",
  backgroundGradientTellentLightPurple: "linear-gradient(90deg, #F7F4FF 0%, #DED3F2 100%)",
  backgroundGradientAiLightPurple: "linear-gradient(87.33deg, #F7F4FF 3.03%, #DED3F2 98.6%)",
  backgroundGradientWorkflowsDefault: "linear-gradient(180deg, rgba(255, 141, 65, 1) 0%, rgba(217, 28, 122, 1) 50%, rgba(90, 28, 183, 1) 100%);",
  backgroundGradientWorkflowsLight: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
  borderNeutralDefault: "#DCD8E4",
  borderNeutralDark: "#C4BCC8",
  borderNeutralDisabled: "#ECE8F3",
  borderNeutralTransparent: "rgba(255,255,255,0.3)",
  borderSystemInfo: "#0661E1",
  borderSystemSuccess: "#00a357",
  borderSystemCritical: "#D10015",
  borderSystemWarning: "#DA6900",
  borderMainPrimary: "#5A1CB7",
  borderMainActive: "#BDA4E2",
  textSystemInfo: "#0551BD",
  textSystemSuccess: "#008546",
  textSystemWarning: "#B85800",
  textSystemCritical: "#B20012",
  textSystemPrimary: "#7627E0",
  textSystemPrimaryDark: "#5A1CB7",
  textMainDefault: "#141217",
  textMainSubdued: "#5D566C",
  textMainDisabled: "#B3AFBB",
  textMainActive: "#481692",
  iconSystemInfo: "#0661E1",
  iconSystemSuccess: "#00a357",
  iconSystemWarning: "#DA6900",
  iconSystemCritical: "#D10015",
  iconSystemPrimary: "#7627E0",
  iconSystemPrimaryDark: "#5A1CB7",
  iconMainBrand: "#5A1CB7",
  iconMainDefault: "#141217",
  iconMainSubdued: "#5D566C",
  iconMainDisabled: "#B3AFBB",
  iconMainActive: "#481692",
  miscSpecialPersonal: "#f09300",
  miscSpecialViolet: "#7986cb",
  miscSpecialOrange: "#b25000",
  miscSpecialOrangeLight: "#FAE8D9",
  miscSpecialYellow: "#F4BB26",
  miscSpecialIndigo: "#102F7A",
  miscSpecialDarkYellow: "#dadabe",
  miscSpecialDarkBlue: "#113883",
  miscSpecialLime: "#9DE000",
  miscSpecialGrayDark: "#6D6976",
  miscSpecialGrayLight: "#ece9f2",
  miscSpecialTurquoise: "#00A4AD",
  miscSpecialTurquoiseLight: "#DCF2F4",
  miscSpecialPurple: "#995CE0",
  miscSpecialPurpleLow: "#DBCFF8",
  miscSpecialPurpleLight: "#EAE5FA",
  miscSpecialBrown: "#946A57",
  miscSpecialBrownLight: "#F5F1EF",
  miscSocialFacebook: "#1877F2",
  miscSocialTwitter: "#3dacf0",
  miscSocialGooglePlus: "#d34836",
  miscSocialLinkedin: "#0A66C2",
  miscSocialX: "#000000",
  miscPublicDefault: "#31bd95",
  miscPublicHover: "#239E7D",
  miscPublicSubdued: "#EAF8F4",
  pricingScaleDefault: "#D91C7A",
  pricingScaleHover: "#AC1660",
  pricingScaleSubdued: "#FCEBF4",
  pricingLeadDefault: "#7148BD",
  pricingLeadHover: "#512FA2",
  pricingLeadSubdued: "#F0ECF8",
  pricingOptimizeDefault: "#7148BD",
  pricingOptimizeHover: "#512FA2",
  pricingOptimizeSubdued: "#F0ECF8",
  pricingGrowDefault: "#D91C7A",
  pricingGrowHover: "#AC1660",
  pricingGrowSubdued: "#FCEBF4",
  pricingStartDefault: "#141217",
  pricingStartHover: "#28242E",
  white: "#fff",
  black: "#000",
  colorBgDefault: "#fff",
  colorBgHover: "#F1EEF6",
  colorBgActive: "#E9E0F5",
  colorBgDisabled: "#DCD8E4",
  colorBgSelected: "#E9E0F5",
  colorBgPrimaryDefault: "#5A1CB7",
  colorBgPrimaryHover: "#481692",
  colorBgPrimaryPressed: "#3f157f",
  colorBgPrimarySelected: "#5A1CB7",
  colorBgPrimaryDisabled: "#9C77D4",
  colorBgPrimarySubduedDefault: "#f0e8f7",
  colorBgPrimarySubduedHover: "#F5F0FA",
  colorBgPrimarySubduedSelected: "#f0e8f7",
  colorBgPrimarySubduedActive: "#F5F0FA",
  colorBgPrimaryStrongDefault: "#481692",
  colorBgPrimaryLowDefault: "#E9E0F5",
  colorBgPrimaryLowHover: "#E9E0F5",
  colorBgPrimaryLowPressed: "#BDA4E2",
  colorBgNeutralDefault: "#f6f5fa",
  colorBgNeutralHover: "#ECE8F3",
  colorBgNeutralPressed: "#DCD8E4",
  colorBgNeutralDisabled: "#C4BCC8",
  colorBgNeutralSelected: "#F1EEF6",
  colorBgNeutralLowDefault: "#FAF9FB",
  colorBgNeutralLowHover: "#E5E3E8",
  colorBgNeutralLowDisabled: "#f6f5fa",
  colorBgNeutralStrongDefault: "#DCD8E4",
  colorBgNeutralStrongHover: "#C4BCC8",
  colorBgSuccessDefault: "#00a357",
  colorBgSuccessHover: "#008546",
  colorBgSuccessPressed: "#006B39",
  colorBgSuccessDisabled: "#75C7A1",
  colorBgSuccessLowDefault: "#d5fbe2",
  colorBgSuccessLowHover: "#d5fbe2",
  colorBgSuccessLowPressed: "#d5fbe2",
  colorBgSuccessSubduedDefault: "#d5fbe2",
  colorBgSuccessSubduedHover: "#C3EAD7",
  colorBgSuccessSubduedPressed: "#75C7A1",
  colorBgCriticalDefault: "#D10015",
  colorBgCriticalHover: "#B20012",
  colorBgCriticalPressed: "#8F000E",
  colorBgCriticalDisabled: "#E87D88",
  colorBgCriticalLowDefault: "#FAE0E3",
  colorBgCriticalLowHover: "#FAE0E3",
  colorBgCriticalLowPressed: "#FAE0E3",
  colorBgCriticalStrongDefault: "#B20012",
  colorBgCriticalStrongActive: "#8F000E",
  colorBgCriticalSubduedDefault: "#fce9ea",
  colorBgCriticalSubduedHover: "#F4C7CC",
  colorBgCriticalSubduedPressed: "#E87D88",
  colorBgWarningDefault: "#DA6900",
  colorBgWarningHover: "#B85800",
  colorBgWarningPressed: "#944700",
  colorBgWarningDisabled: "#EBAE75",
  colorBgWarningLowDefault: "#FFEDDB",
  colorBgWarningLowHover: "#FFEDDB",
  colorBgWarningLowPressed: "#FFEDDB",
  colorBgWarningSubduedDefault: "#FFEDDB",
  colorBgWarningSubduedHover: "#FFDDBD",
  colorBgWarningSubduedPressed: "#EBAE75",
  colorBgScaleDefault: "#D91C7A",
  colorBgScaleHover: "#AC1660",
  colorBgScaleSubduedDefault: "#FCEBF4",
  colorBgLeadDefault: "#7148BD",
  colorBgLeadHover: "#512FA2",
  colorBgLeadSubduedDefault: "#F0ECF8",
  colorBgPrivateDefault: "#FFF8D1",
  colorBgPrivateHover: "#EAE2B8",
  colorBgPrivateStrongDefault: "#EAE2B8",
  colorBgPrivateLowDefault: "#FFFBE5",
  colorBgGradientSubdued: "linear-gradient(180deg, #FFFFFF 0%, #F5F8F9 100%)",
  colorBgSecondaryDefault: "#5D566C",
  colorBgSecondaryDisabled: "#E5E3E8",
  colorBgSecondaryStrongDefault: "#141217",
  colorBgSecondaryStrongHover: "#3A3543",
  colorBgSecondaryStrongPressed: "#4D465A",
  colorBgSecondaryStrongActive: "#28242E",
  colorBgSecondarySubduedDefault: "#DAD7DE",
  colorBgSecondaryLowDefault: "#7E788B",
  colorBgSecondaryLowDisabled: "#B3AFBB",
  colorBgInfoDefault: "#0661E1",
  colorBgInfoHover: "#0551BD",
  colorBgInfoPressed: "#044095",
  colorBgInfoDisabled: "#72A5EE",
  colorBgInfoStrongDefault: "#0551BD",
  colorBgInfoLowDefault: "#E1ECFE",
  colorBgInfoLowHover: "#E1ECFE",
  colorBgInfoLowPressed: "#E1ECFE",
  colorBgOverdueDefault: "#b25000",
  colorBgOverdueLowDefault: "#FAE8D9",
  colorBgNoconsentDefault: "#FAE8D9",
  colorBgNodataDefault: "#FAE8D9",
  colorBgTeamDefault: "#7986cb",
  colorBgPersonalDefault: "#f09300",
  colorBgOverlayDefault: "rgba(36,38,46,0.7)",
  colorBgOnoverlayHover: "rgba(255,255,255,0.1)",
  colorBgOnoverlayPressed: "rgba(255,255,255,0.2)",
  colorBgGhostHover: "rgba(255,255,255,0.1)",
  colorBgGhostPressed: "rgba(255,255,255,0.2)",
  colorBgTintDefault: "rgba(255,255,255,0.3)",
  colorBgLoadingDefault: "rgba(255,255,255,0.15)",
  colorBgOfferDefault: "#995CE0",
  colorBgOfferHover: "#7D43C3",
  colorBgOfferPressed: "#602D9F",
  colorBgOfferLowDefault: "#EAE5FA",
  colorBgOfferLowHover: "#EAE5FA",
  colorBgRequisitionSubduedDefault: "#EAE5FA",
  colorBgScreeningDefault: "#0551BD",
  colorBgScreeningHover: "#044095",
  colorBgScreeningPressed: "#032D68",
  colorBgScreeningLowDefault: "#E1ECFE",
  colorBgInterviewDefault: "#0661E1",
  colorBgInterviewHover: "#0551BD",
  colorBgInterviewPressed: "#044095",
  colorBgInterviewLowDefault: "#E1ECFE",
  colorBgEvaluationDefault: "#00A4AD",
  colorBgEvaluationHover: "#00858C",
  colorBgEvaluationPressed: "#006A70",
  colorBgEvaluationLowDefault: "#DCF2F4",
  colorBgEvaluationLowHover: "#DCF2F4",
  colorBgJobSubduedDefault: "#DCF2F4",
  colorBgHiredDefault: "#00a357",
  colorBgHiredHover: "#008546",
  colorBgHiredPressed: "#006B39",
  colorBgHiredLowDefault: "#d5fbe2",
  colorBgTranslateDefault: "#DA6900",
  colorBgChartDefault: "rgba(90, 28, 183, 0.1)",
  colorBgVersatileSecondaryStrongDefault: "#1E1B22",
  colorBgVersatileSecondaryStrongHover: "#393542",
  colorBgVersatileSecondaryStrongPressed: "#4C4659",
  colorBgVersatileSecondaryStrongActive: "#27242D",
  colorBgVersatileSecondaryDefault: "#5C566A",
  colorBgVersatileSecondaryHover: "#4C4659",
  colorBgVersatileSecondaryMediumDefault: "#393542",
  colorBgVersatileSecondaryMediumHover: "#4C4659",
  colorBgVersatileSecondaryMediumActive: "#5C566A",
  colorBgSkeletonDefault: "#F1EEF6",
  colorBgOncomponentDefault: "#fff",
  colorBgOncomponentHover: "#fff",
  colorBgOncomponentActive: "#fff",
  colorBgOptimizeDefault: "#7148BD",
  colorBgOptimizeHover: "#512FA2",
  colorBgOptimizeSubduedDefault: "#F0ECF8",
  colorBgGrowDefault: "#D91C7A",
  colorBgGrowHover: "#AC1660",
  colorBgGrowSubduedDefault: "#FCEBF4",
  colorBgStartDefault: "#141217",
  colorBgStartHover: "#28242E",
  colorBgOnboardingDefault: "#A2008C",
  colorBgOnboardingHover: "#A2008C",
  colorBgOnboardingLowDefault: "#FFD7FA",
  colorBgOnboardingLowActive: "#EDAFE5",
  colorBgOnboardingSubduedDefault: "#FFE3FB",
  colorBgTellentDefault: "#E83393",
  colorBgTellentHover: "#CC287F",
  colorBgTellentPressed: "#951B5C",
  colorBgTellentActive: "#FCE3F0",
  colorBgAppliedDefault: "#6D6976",
  colorBgAppliedHover: "#55515c",
  colorBgAppliedPressed: "#37353b",
  colorBgAppliedLowDefault: "#ece9f2",
  colorBgNotypeDefault: "#946A57",
  colorBgNotypeHover: "#7C5442",
  colorBgNotypePressed: "#5F3E30",
  colorBgNotypeLowDefault: "#F5F1EF",
  colorBgKiwiDefault: "#007838",
  colorBgKiwiHover: "#00602D",
  colorBgKiwiPressed: "#004822",
  colorBgKiwiSubduedHover: "#D9EBE1",
  colorBgJaveloDefault: "#D14905",
  colorBgJaveloHover: "#F8E4DA",
  colorBgRecruiteeDefault: "#5A1CB7",
  colorBgPublicSubduedDefault: "#EAF8F4",
  colorBgArticleTurquoiseSubduedDefault: "#DCF2F4",
  colorBgArticlePurpleSubduedDefault: "#EAE5FA",
  colorBgAccentDefault: "#D91C7A",
  colorBgAccentHover: "#D91C7A",
  colorBgAccentPressed: "#b61666",
  colorBgAccentActive: "#D91C7A",
  colorBgAccentSubduedDefault: "#FCEBF4",
  colorBgAccentSubduedHover: "#FCEBF4",
  colorBgAccentSubduedPressed: "#FCEBF4",
  colorBgAccentStrongDefault: "#b61666",
  colorBgImpactDefault: "#5A1CB7",
  colorBgImpactLowPressed: "#B19CD8",
  colorBgImpactSubduedDefault: "#E9E2F6",
  colorBgImpactSubduedHover: "#EEE9F8",
  colorBgAttendanceSubduedDefault: "#FFEDF5",
  colorBgEmployeesSubduedDefault: "#FFF3E5",
  colorBgTimeoffSubduedDefault: "#E9F3FF",
  colorBgCompanySubduedDefault: "#EBFAFB",
  colorBgPayrollSubduedDefault: "#F7E6F8",
  colorBgExpensesSubduedDefault: "#E6E6F4",
  colorBgReportsSubduedDefault: "#E8F9EE",
  colorBgQuoteDefault: "#BB89E0",
  colorBgWorkflowsDefault: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
  colorBgWorkflowsHover: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
  colorTextDefault: "#5D566C",
  colorTextHover: "#141217",
  colorTextPressed: "#141217",
  colorTextDisabled: "#B3AFBB",
  colorTextActive: "#481692",
  colorTextStrongDefault: "#141217",
  colorTextStrongHover: "#141217",
  colorTextStrongSelected: "#141217",
  colorTextLowDefault: "#7E788B",
  colorTextOnprimaryDefault: "#fff",
  colorTextOnprimaryHover: "#fff",
  colorTextOnprimaryPressed: "#fff",
  colorTextOnprimaryDisabled: "#fff",
  colorTextOnprimarySelected: "#fff",
  colorTextOnneutralDisabled: "#fff",
  colorTextOnsuccessDefault: "#fff",
  colorTextOnsuccessHover: "#fff",
  colorTextOnsuccessPressed: "#fff",
  colorTextOncriticalDefault: "#fff",
  colorTextOncriticalHover: "#fff",
  colorTextOncriticalPressed: "#fff",
  colorTextOnwarningDefault: "#fff",
  colorTextOnwarningHover: "#fff",
  colorTextOnwarningPressed: "#fff",
  colorTextSuccessDefault: "#00a357",
  colorTextSuccessHover: "#00a357",
  colorTextSuccessPressed: "#008546",
  colorTextSuccessStrongDefault: "#008546",
  colorTextSuccessStrongHover: "#006B39",
  colorTextSuccessStrongPressed: "#00522B",
  colorTextCriticalDefault: "#D10015",
  colorTextCriticalHover: "#D10015",
  colorTextCriticalPressed: "#B20012",
  colorTextCriticalStrongDefault: "#B20012",
  colorTextCriticalStrongHover: "#8F000E",
  colorTextCriticalStrongPressed: "#66000A",
  colorTextInfoDefault: "#0661E1",
  colorTextInfoHover: "#0661E1",
  colorTextInfoPressed: "#0551BD",
  colorTextInfoStrongDefault: "#0551BD",
  colorTextWarningDefault: "#DA6900",
  colorTextWarningHover: "#DA6900",
  colorTextWarningPressed: "#B85800",
  colorTextWarningStrongDefault: "#B85800",
  colorTextWarningStrongHover: "#944700",
  colorTextWarningStrongPressed: "#6B3400",
  colorTextOnscaleDefault: "#fff",
  colorTextOnscaleHover: "#fff",
  colorTextOnleadDefault: "#fff",
  colorTextOnleadHover: "#fff",
  colorTextScaleDefault: "#D91C7A",
  colorTextScaleHover: "#AC1660",
  colorTextOngradientDefault: "#fff",
  colorTextLeadDefault: "#7148BD",
  colorTextOnsecondaryDefault: "#fff",
  colorTextOnsecondaryStrongDefault: "#fff",
  colorTextOnsecondaryStrongHover: "#fff",
  colorTextOnsecondaryStrongPressed: "#fff",
  colorTextOninfoStrongDefault: "#fff",
  colorTextOninfoDefault: "#fff",
  colorTextOninfoHover: "#fff",
  colorTextOninfoPressed: "#fff",
  colorTextOverdueDefault: "#b25000",
  colorTextOnoverdueDefault: "#fff",
  colorTextNoconsentDefault: "#b25000",
  colorTextNodataDefault: "#b25000",
  colorTextOnoverlayDefault: "#fff",
  colorTextOnoverlayHover: "#fff",
  colorTextOnoverlayPressed: "#fff",
  colorTextOnoverlayDisabled: "#7E788B",
  colorTextOnoverlayLowDefault: "#ECE8F3",
  colorTextOnghostDefault: "#fff",
  colorTextOnghostHover: "#fff",
  colorTextOnghostPressed: "#fff",
  colorTextOnghostDisabled: "#7E788B",
  colorTextPrimaryDefault: "#5A1CB7",
  colorTextPrimaryHover: "#481692",
  colorTextPrimaryPressed: "#481692",
  colorTextPrimaryActive: "#5A1CB7",
  colorTextPrimaryStrongDefault: "#481692",
  colorTextPrimaryStrongActive: "#481692",
  colorTextOnteamDefault: "#fff",
  colorTextOncomponentDefault: "#fff",
  colorTextOnoptimizeDefault: "#fff",
  colorTextOnoptimizeHover: "#fff",
  colorTextOptimizeDefault: "#7148BD",
  colorTextOptimizeHover: "#512FA2",
  colorTextOngrowDefault: "#fff",
  colorTextOngrowHover: "#fff",
  colorTextGrowDefault: "#D91C7A",
  colorTextGrowHover: "#AC1660",
  colorTextOnstartDefault: "#fff",
  colorTextOnstartHover: "#fff",
  colorTextOnboardingLowDefault: "#EDCFE9",
  colorTextOnboardingDefault: "#57054C",
  colorTextOnonboardingDefault: "#fff",
  colorTextOnonboardingHover: "#fff",
  colorTextOntellentDefault: "#fff",
  colorTextOntellentHover: "#fff",
  colorTextOntellentPressed: "#fff",
  colorTextOnappliedDefault: "#fff",
  colorTextOnappliedHover: "#fff",
  colorTextOnappliedPressed: "#fff",
  colorTextOnscreeningDefault: "#fff",
  colorTextOnscreeningHover: "#fff",
  colorTextOnscreeningPressed: "#fff",
  colorTextOninterviewDefault: "#fff",
  colorTextOninterviewHover: "#fff",
  colorTextOninterviewPressed: "#fff",
  colorTextOnevaluationDefault: "#fff",
  colorTextOnevaluationHover: "#fff",
  colorTextOnevaluationPressed: "#fff",
  colorTextOnofferDefault: "#fff",
  colorTextOnofferHover: "#fff",
  colorTextOnofferPressed: "#fff",
  colorTextOnhiredDefault: "#fff",
  colorTextOnhiredHover: "#fff",
  colorTextOnhiredPressed: "#fff",
  colorTextOnnotypeDefault: "#fff",
  colorTextOnnotypeHover: "#fff",
  colorTextOnnotypePressed: "#fff",
  colorTextOnkiwiDefault: "#fff",
  colorTextOnkiwiHover: "#fff",
  colorTextOnkiwiPressed: "#fff",
  colorTextOnjaveloDefault: "#fff",
  colorTextOnrecruiteeDefault: "#fff",
  colorTextRecruiteeDefault: "#5A1CB7",
  colorTextRecruiteeStrongDefault: "#481692",
  colorTextKiwiStrongDefault: "#007838",
  colorTextKiwiDefault: "#007838",
  colorTextAccentDefault: "#D91C7A",
  colorTextAccentHover: "#b61666",
  colorTextAccentPressed: "#b61666",
  colorTextOnaccentDefault: "#fff",
  colorTextOnaccentHover: "#fff",
  colorTextOnaccentPressed: "#fff",
  colorTextImpactDefault: "#5A1CB7",
  colorTextImpactHover: "#481692",
  colorTextImpactPressed: "#481692",
  colorTextAiDefault: "#6F52E2",
  colorTextLinkDefault: "#7627E0",
  colorTextLinkHover: "#5A1CB7",
  colorTextOfferDefault: "#995CE0",
  colorIconDefault: "#5D566C",
  colorIconHover: "#141217",
  colorIconPressed: "#141217",
  colorIconDisabled: "#B3AFBB",
  colorIconActive: "#481692",
  colorIconStrongDefault: "#141217",
  colorIconOnprimaryDefault: "#fff",
  colorIconOnprimaryHover: "#fff",
  colorIconOnprimaryPressed: "#fff",
  colorIconOnprimaryDisabled: "#fff",
  colorIconOnneutralDisabled: "#fff",
  colorIconOnsuccessDefault: "#fff",
  colorIconOnsuccessHover: "#fff",
  colorIconOnsuccessPressed: "#fff",
  colorIconOnsuccessDisabled: "#fff",
  colorIconOncriticalDefault: "#fff",
  colorIconOncriticalHover: "#fff",
  colorIconOncriticalPressed: "#fff",
  colorIconOnwarningDefault: "#fff",
  colorIconOnwarningHover: "#fff",
  colorIconOnwarningPressed: "#fff",
  colorIconSuccessDefault: "#00a357",
  colorIconSuccessHover: "#00a357",
  colorIconSuccessPressed: "#008546",
  colorIconSuccessActive: "#006B39",
  colorIconSuccessStrongDefault: "#008546",
  colorIconSuccessStrongHover: "#006B39",
  colorIconSuccessStrongPressed: "#00522B",
  colorIconCriticalDefault: "#D10015",
  colorIconCriticalHover: "#D10015",
  colorIconCriticalPressed: "#B20012",
  colorIconCriticalStrongDefault: "#B20012",
  colorIconCriticalStrongHover: "#8F000E",
  colorIconCriticalStrongPressed: "#66000A",
  colorIconInfoDefault: "#0661E1",
  colorIconInfoHover: "#0661E1",
  colorIconInfoPressed: "#0551BD",
  colorIconInfoStrongDefault: "#0551BD",
  colorIconWarningDefault: "#DA6900",
  colorIconWarningHover: "#DA6900",
  colorIconWarningPressed: "#B85800",
  colorIconWarningStrongDefault: "#B85800",
  colorIconWarningStrongHover: "#944700",
  colorIconWarningStrongPressed: "#6B3400",
  colorIconScaleDefault: "#D91C7A",
  colorIconScaleHover: "#AC1660",
  colorIconOngradientDefault: "#fff",
  colorIconOnscaleDefault: "#fff",
  colorIconOnscaleHover: "#fff",
  colorIconLeadDefault: "#7148BD",
  colorIconOnleadDefault: "#fff",
  colorIconOnleadHover: "#fff",
  colorIconOnsecondaryDefault: "#fff",
  colorIconOnsecondaryStrongDefault: "#fff",
  colorIconOnsecondaryStrongHover: "#fff",
  colorIconOninfoStrongDefault: "#fff",
  colorIconOninfoDefault: "#fff",
  colorIconOninfoHover: "#fff",
  colorIconOninfoPressed: "#fff",
  colorIconOverdueDefault: "#b25000",
  colorIconOnoverdueDefault: "#fff",
  colorIconNoconsentDefault: "#b25000",
  colorIconNodataDefault: "#b25000",
  colorIconOnoverlayDefault: "#fff",
  colorIconOnoverlayHover: "#fff",
  colorIconOnoverlayPressed: "#fff",
  colorIconOnoverlayDisabled: "#7E788B",
  colorIconOnghostDefault: "#fff",
  colorIconOnghostHover: "#fff",
  colorIconOnghostPressed: "#fff",
  colorIconOnghostDisabled: "#7E788B",
  colorIconPrimaryDefault: "#5A1CB7",
  colorIconPrimaryHover: "#481692",
  colorIconPrimaryPressed: "#5A1CB7",
  colorIconPrimaryStrongDefault: "#481692",
  colorIconPrimaryStrongPressed: "#481692",
  colorIconLowDefault: "#7E788B",
  colorIconLowHover: "#5D566C",
  colorIconLowDisabled: "#C4BCC8",
  colorIconSubduedDefault: "#DAD7DE",
  colorIconOncomponentDefault: "#fff",
  colorIconAiDefault: "#6F52E2",
  colorIconTranslateDefault: "#DA6900",
  colorIconOptimizeDefault: "#7148BD",
  colorIconOptimizeHover: "#512FA2",
  colorIconOnoptimizeDefault: "#fff",
  colorIconOnoptimizeHover: "#fff",
  colorIconGrowDefault: "#D91C7A",
  colorIconGrowHover: "#AC1660",
  colorIconOngrowDefault: "#fff",
  colorIconOngrowHover: "#fff",
  colorIconOnboardingDefault: "#A2008C",
  colorIconOnboardingLowDefault: "#EDCFE9",
  colorIconOnonboardingDefault: "#fff",
  colorIconOnonboardingHover: "#fff",
  colorIconOnhiredDefault: "#fff",
  colorIconOnhiredHover: "#fff",
  colorIconOnhiredPressed: "#fff",
  colorIconOnkiwiDefault: "#fff",
  colorIconOnkiwiHover: "#fff",
  colorIconOnkiwiPressed: "#fff",
  colorIconOnjaveloDefault: "#fff",
  colorIconOnappliedDefault: "#fff",
  colorIconOnappliedHover: "#fff",
  colorIconOnappliedPressed: "#fff",
  colorIconOnscreeningDefault: "#fff",
  colorIconOnscreeningHover: "#fff",
  colorIconOnscreeningPressed: "#fff",
  colorIconOninterviewDefault: "#fff",
  colorIconOninterviewHover: "#fff",
  colorIconOninterviewPressed: "#fff",
  colorIconOnevaluationDefault: "#fff",
  colorIconOnevaluationHover: "#fff",
  colorIconOnevaluationPressed: "#fff",
  colorIconOnofferDefault: "#fff",
  colorIconOnofferHover: "#fff",
  colorIconOnofferPressed: "#fff",
  colorIconOnnotypeDefault: "#fff",
  colorIconOnnotypeHover: "#fff",
  colorIconOnnotypePressed: "#fff",
  colorIconOntellentDefault: "#fff",
  colorIconOntellentHover: "#fff",
  colorIconOntellentPressed: "#fff",
  colorIconTellentDefault: "#E83393",
  colorIconTellentActive: "#E83393",
  colorIconOfferDefault: "#995CE0",
  colorIconEvaluationDefault: "#00A4AD",
  colorIconPublicDefault: "#31bd95",
  colorIconRecruiteeDefault: "#5A1CB7",
  colorIconKiwiDefault: "#007838",
  colorIconRequisitionDefault: "#995CE0",
  colorIconJobDefault: "#00A4AD",
  colorIconArticleTurquoiseDefault: "#00A4AD",
  colorIconArticlePurpleDefault: "#995CE0",
  colorIconAccentDefault: "#D91C7A",
  colorIconAccentHover: "#b61666",
  colorIconAccentPressed: "#b61666",
  colorIconOnaccentDefault: "#fff",
  colorIconOnaccentHover: "#fff",
  colorIconOnaccentPressed: "#fff",
  colorIconImpactDefault: "#5A1CB7",
  colorIconImpactHover: "#481692",
  colorIconImpactPressed: "#481692",
  colorIconAttendanceDefault: "#F65978",
  colorIconTimeoffDefault: "#61A5FF",
  colorIconEmployeesDefault: "#FFAA45",
  colorIconCompanyDefault: "#34D0D7",
  colorIconPayrollDefault: "#C746CB",
  colorIconExpensesDefault: "#0E0BC7",
  colorIconReportsDefault: "#56D586",
  colorIconLinkDefault: "#7627E0",
  colorIconLinkHover: "#5A1CB7",
  colorIconWorkflowsDefault: "linear-gradient(180deg, rgba(255, 141, 65, 1) 0%, rgba(217, 28, 122, 1) 50%, rgba(90, 28, 183, 1) 100%);",
  colorBorderAiDefault: "#6F52E2",
  colorBorderDefault: "#DCD8E4",
  colorBorderHover: "#DCD8E4",
  colorBorderPressed: "#DCD8E4",
  colorBorderDisabled: "#ECE8F3",
  colorBorderSelected: "#DCD8E4",
  colorBorderActive: "#BDA4E2",
  colorBorderSuccessDefault: "#00a357",
  colorBorderSuccessHover: "#00a357",
  colorBorderSuccessPressed: "#008546",
  colorBorderSuccessSubduedDefault: "#C3EAD7",
  colorBorderSuccessLowDefault: "#36B579",
  colorBorderCriticalDefault: "#D10015",
  colorBorderCriticalHover: "#D10015",
  colorBorderCriticalPressed: "#B20012",
  colorBorderCriticalLowDefault: "#E87D88",
  colorBorderCriticalSubduedDefault: "#F4C7CC",
  colorBorderInfoDefault: "#0661E1",
  colorBorderInfoHover: "#0661E1",
  colorBorderInfoPressed: "#0551BD",
  colorBorderInfoSubduedDefault: "#BED9FD",
  colorBorderWarningDefault: "#DA6900",
  colorBorderWarningHover: "#DA6900",
  colorBorderWarningPressed: "#B85800",
  colorBorderWarningDisabled: "#EBAE75",
  colorBorderWarningSubduedDefault: "#FFDDBD",
  colorBorderNeutralHover: "#C4BCC8",
  colorBorderNeutralDisabled: "#f6f5fa",
  colorBorderOncomponentDefault: "#fff",
  colorBorderSecondaryDefault: "#5D566C",
  colorBorderSecondaryHover: "#141217",
  colorBorderSecondaryDisabled: "#B3AFBB",
  colorBorderSecondaryLowDefault: "#7E788B",
  colorBorderSecondaryLowDisabled: "#CAC7D0",
  colorBorderSecondaryStrongDefault: "#3A3543",
  colorBorderPrimaryDefault: "#5A1CB7",
  colorBorderPrimaryHover: "#481692",
  colorBorderPrimaryStrongDefault: "#481692",
  colorBorderPrimarySubduedDefault: "#BDA4E2",
  colorBorderPrimaryLowDefault: "#7B49C5",
  colorBorderTranslateDefault: "#DA6900",
  colorBorderOnghostDefault: "#fff",
  colorBorderOnghostHover: "#fff",
  colorBorderOnghostPressed: "#fff",
  colorBorderOnghostDisabled: "#7E788B",
  colorBorderPrivateDefault: "#dadabe",
  colorBorderStrongDefault: "#C4BCC8",
  colorBorderStrongDisabled: "#C4BCC8",
  colorBorderLowDefault: "#ECE8F3",
  colorBorderLowHover: "#DAD7DE",
  colorBorderTeamDefault: "#7986cb",
  colorBorderVersatileSecondaryDefault: "#5C566A",
  colorBorderTintDefault: "rgba(255,255,255,0.3)",
  colorBorderAccentDefault: "#D91C7A",
  colorBorderAccentHover: "#b61666",
  colorBorderAccentPressed: "#b61666",
  colorBorderAccentSubduedDefault: "#F6CBE0",
  colorBorderImpactDefault: "#B19CD8",
  colorBorderImpactHover: "#B19CD8",
  colorBorderImpactPressed: "#B19CD8",
  colorBorderOnprimaryDefault: "#fff",
  colorBorderOnprimaryHover: "#fff",
  colorBorderOnprimaryPressed: "#fff",
  colorBorderOfferSubduedDefault: "#DBCFF8",
  colorGradientPrimary: "linear-gradient(270deg, #1999E3 0%, #102F7A 100%)",
  colorGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
  colorGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
  colorGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
  colorGradientPurple: "linear-gradient(-90deg, #ca8bdb 30%, #7148bd 70%)",
  colorGradientOrange: "linear-gradient(90deg, #de6603 27.46%, #f4bb26 100%)",
  colorGradientRed: "linear-gradient(90deg, #FA2D4C 27.46%, #FFDBD4 100%)",
  colorGradientLightBlue: "linear-gradient(45deg, #1999E3 0%, #7cccfa 100%)",
  colorGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
  colorGradientVideoOverlay: "linear-gradient(45deg, rgba(#174298, 0.7) 0%, rgba(#7148bd, 0.7) 52%, rgba(#af7ee6, 0.7) 100%)",
  colorGradientFindTimeNeutral: "repeating-linear-gradient(135deg, #E8EDF1, #E8EDF1 6px, #C7D0D7 6px, #C7D0D7 12px)",
  colorGradientFindTimePrimary: "repeating-linear-gradient(135deg, #E9E0F5, #E9E0F5 6px, #BDA4E2 6px, #BDA4E2 12px)",
  colorGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
  colorGradientTruncate: "#FFFFFF00",
  colorGradientShimmer: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%",
  colorGradientRainbow: "linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)",
  colorGradientNeutralToTransparent: "linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)",
  colorGradientTellent: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
  colorGradientPink: "linear-gradient(90deg, #5A1CB7 0%, #D91C7A 100%)",
  colorGradientImpact: "linear-gradient(90deg, #F7F4FF 0%, #DED3F2 100%)",
  colorGradientAi: "linear-gradient(87.33deg, #F7F4FF 3.03%, #DED3F2 98.6%)",
  colorGradientGrow: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
  colorGradientWorkflows: "linear-gradient(180deg, rgba(255, 141, 65, 1) 0%, rgba(217, 28, 122, 1) 50%, rgba(90, 28, 183, 1) 100%);",
  colorGradientWorkflowsLight: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
  colorTooltipFeature: "#113883",
  colorTooltipFeatureLight: "#198FD9",
  colorAvatarSteelLighter: "#7055AA",
  colorAvatarSteelLight: "#DAD7DE",
  colorAvatarSteelDark: "#5D566C",
  colorAvatarGrayLight: "#ECE8F3",
  colorAvatarGrayDark: "#8A8198",
  colorAvatarGreen: "#048B5D",
  colorAvatarBlueLight: "#147AB6",
  colorAvatarBlueDark: "#B7427C",
  colorAvatarBlueDarker: "#300f61",
  colorAvatarPink: "#9A4CB6",
  colorAvatarPurple: "#512FA2",
  colorAvatarYellow: "#DA6900",
  colorAvatarOrange: "#b25000",
  colorAvatarSkeleton: "#F1EEF6",
  colorChartPrimaryDefault: "#8659CA",
  colorChartBlueDefault: "#F47174",
  colorChartTurquoiseDefault: "#008EE5",
  colorChartPurpleDefault: "#E566A5",
  colorChartPurpleSubduedDefault: "#03AD9C",
  colorChartGrayDefault: "#A6A2AF",
  colorChartGreenDefault: "#45C2D1",
  colorChartGreenSubduedDefault: "#CD75BC",
  colorChartBlueStrongDefault: "#FFD76F",
  colorChartYellowDefault: "#FEB07B",
  colorChartYellowSubduedDefault: "#6871EE",
  colorChartOrangeDefault: "#B2A1F7",
  colorSeparatorTransparent: "rgba(255,255,255,0.3)",
  colorLogoTypographyDefault: "#5A1CB7",
  colorLogoTypographyStrongDefault: "#330066",
  colorLogoSignSubduedDefault: "#ECE0F5",
  colorLogoSignPrimaryDefault: "#5A1CB7",
  colorLogoSignAccentDefault: "#E23393",
  colorCandidatesBgPrimaryDefault: "#8659CA",
  colorCandidatesBgGreenStrongDefault: "#1EA275",
  colorCandidatesBgOrangeDefault: "#DE6603",
  colorCandidatesBgYellowDefault: "#F4BB26",
  colorCandidatesBgGreenSubduedDefault: "#31BD95",
  colorCandidatesBgBlueDefault: "#0C6090",
  colorCandidatesBgVioletDefault: "#512FA2",
  colorCandidatesBgGreenDefault: "#4FC510",
  colorCandidatesBgBlueStrongDefault: "#083F5E",
  colorCandidatesBgPurpleDefault: "#9A4CB6",
  colorCandidatesBorderPrimaryDefault: "#8659CA",
  colorCandidatesBorderGreenStrongDefault: "#1EA275",
  colorCandidatesBorderOrangeDefault: "#DE6603",
  colorCandidatesBorderYellowDefault: "#F4BB26",
  colorCandidatesBorderGreenSubduedDefault: "#31BD95",
  colorCandidatesBorderBlueDefault: "#0C6090",
  colorCandidatesBorderVioletDefault: "#512FA2",
  colorCandidatesBorderGreenDefault: "#4FC510",
  colorCandidatesBorderBlueStrongDefault: "#083F5E",
  colorCandidatesBorderPurpleDefault: "#9A4CB6",
  colorScrollbarThumbDefault: "#c7c7c7",
  colorScrollbarThumbHover: "#878787",
  colorScrollbarTrackDefault: "#fafafa",
  colorMarketplaceLogo: "#F1F4F7",
  colorMarketplaceRibbon: "#006B39",
  colorVersatileDefault: "#fff",
  colorFacebookDefault: "#1877F2",
  colorXDefault: "#000000",
  colorGoogleplusDefault: "#d34836",
  colorLinkedinDefault: "#0A66C2",
  colorNavBgNeutralDefault: "#FAF9FC",
  colorNavBgNeutralLowHover: "#ECE8F3",
  colorNavBgActive: "#E9E0F5",
  colorNavBgPrimarySubduedDefault: "#ECE0F5",
  colorNavTextDefault: "#5D566C",
  colorNavTextStrongDefault: "#141217",
  colorNavTextPrimaryActive: "#5A1CB7",
  colorNavTextLowDefault: "#7E788B",
  colorNavIconDefault: "#5D566C",
  colorNavIconStrongDefault: "#141217",
  colorNavIconPrimaryDefault: "#5A1CB7",
  colorNavIconDisabled: "#B3AFBB",
  colorNavBorderDefault: "#DCD8E4",
  tellentShadowBorderFormFocusDefault: [{"x":"0","y":"0","blur":"0","spread":"3","color":"rgba(90,28,183,0.2)","type":"dropShadow"}],
  kiwiShadowBorderFormFocusDefault: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(0,120,56,0.2)","type":"dropShadow"}],
  tellentShadowBorderCardActive: [{"x":"0","y":"0","blur":"0","spread":"4","color":"rgba(90,28,183,0.2)","type":"dropShadow"}],
  kiwiShadowBorderCardActive: [{"x":"0","y":"0","blur":"0","spread":"4","color":"rgba(90,28,183,0.2)","type":"dropShadow"}],
  tellentShadowBorderCardHover: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(90,28,183,1)","type":"dropShadow"}],
  kiwiShadowBorderCardHover: [{"x":"0","y":"0","blur":"0","spread":"2","color":"rgba(0,120,56,1)","type":"dropShadow"}],
  avatarSteelLighter: "#7055AA",
  avatarSteelLight: "#DAD7DE",
  avatarSteelDark: "#5D566C",
  avatarGrayLight: "#ECE8F3",
  avatarGrayDark: "#8A8198",
  avatarGreen: "#048B5D",
  avatarBlueLight: "#147AB6",
  avatarBlueDark: "#B7427C",
  avatarBlueDarker: "#300f61",
  avatarPink: "#9A4CB6",
  avatarPurple: "#512FA2",
  avatarYellow: "#DA6900",
  avatarOrange: "#b25000",
  avatarSkeleton: "#F1EEF6",
  chartBrandDefault: "#8659CA",
  chartSkyDefault: "#F47174",
  chartOceanDefault: "#008EE5",
  chartOrchidDefault: "#E566A5",
  chartLavenderDefault: "#03AD9C",
  chartSteelDefault: "#A6A2AF",
  chartEmeraldDefault: "#45C2D1",
  chartMintDefault: "#CD75BC",
  chartCobaltDefault: "#FFD76F",
  chartSunflowerDefault: "#FEB07B",
  chartLemonDefault: "#6871EE",
  chartPumpkinDefault: "#B2A1F7",
  candidatesBgBrandDefault: "#8659CA",
  candidatesBgRainforestDefault: "#1EA275",
  candidatesBgFireDefault: "#DE6603",
  candidatesBgGoldDefault: "#F4BB26",
  candidatesBgJungleDefault: "#31BD95",
  candidatesBgNavyDefault: "#0C6090",
  candidatesBgEggplantDefault: "#512FA2",
  candidatesBgGrassDefault: "#4FC510",
  candidatesBgDenimDefault: "#083F5E",
  candidatesBgLilacDefault: "#9A4CB6",
  candidatesBorderBrandDefault: "#8659CA",
  candidatesBorderRainforestDefault: "#1EA275",
  candidatesBorderFireDefault: "#DE6603",
  candidatesBorderGoldDefault: "#F4BB26",
  candidatesBorderJungleDefault: "#31BD95",
  candidatesBorderNavyDefault: "#0C6090",
  candidatesBorderEggplantDefault: "#512FA2",
  candidatesBorderGrassDefault: "#4FC510",
  candidatesBorderDenimDefault: "#083F5E",
  candidatesBorderLilacDefault: "#9A4CB6",
  aiDefault: "#6F52E2",
  productRecruitee50: "#f0e8f7",
  productRecruitee100: "#E9E0F5",
  productRecruitee200: "#BDA4E2",
  productRecruitee300: "#9C77D4",
  productRecruitee400: "#7B49C5",
  productRecruitee500: "#5A1CB7",
  productRecruitee600: "#481692",
  productRecruitee700: "#3f157f",
  productRecruitee800: "#300f61",
  productRecruitee900: "#1a0835",
  productKiwi50: "#F8FFFB",
  productKiwi100: "#D9EBE1",
  productKiwi200: "#95C9AD",
  productKiwi300: "#63AE86",
  productKiwi400: "#32935F",
  productKiwi500: "#007838",
  productKiwi600: "#00602D",
  productKiwi700: "#004822",
  productKiwi800: "#003016",
  productKiwi900: "#002411",
  productJavelo50: "#fff5f0",
  productJavelo100: "#F8E4DA",
  productJavelo200: "#ECAA89",
  productJavelo300: "#E38A5D",
  productJavelo400: "#DA6931",
  productJavelo500: "#D14905",
  productJavelo600: "#A73A04",
  productJavelo700: "#7D2C03",
  productJavelo800: "#541D02",
  productJavelo900: "#3F1602",
  productTellent50: "#FDEBF4",
  productTellent100: "#FCE3F0",
  productTellent200: "#F6B3D7",
  productTellent300: "#EF73B5",
  productTellent400: "#EC53A4",
  productTellent500: "#E83393",
  productTellent600: "#CC287F",
  productTellent700: "#951B5C",
  productTellent800: "#5E0B37",
  productTellent900: "#420027",
  onboardingBackgroundDefault: "#A2008C",
  onboardingBackgroundLoader: "#EDAFE5",
  onboardingBackgroundLow: "#FFD7FA",
  onboardingBackgroundSubdued: "#FFE3FB",
  onboardingTextDefault: "#57054C",
  onboardingTextLow: "#EDCFE9",
  onboardingIconDefault: "#A2008C",
  onboardingIconLow: "#EDCFE9",
  articleOceanDefault: "#00A4AD",
  articleOceanSubduedDefault: "#DCF2F4",
  articleOrchidDefault: "#995CE0",
  articleOrchidSubduedDefault: "#EAE5FA",
  billingPink: "#F65978",
  billingPinkLight: "#FFEDF5",
  billingOrange: "#FFAA45",
  billingOrangeLight: "#FFF3E5",
  billingBlue: "#61A5FF",
  billingBlueLight: "#E9F3FF",
  billingTurquoise: "#34D0D7",
  billingTurquoiseLight: "#EBFAFB",
  billingPurple: "#C746CB",
  billingPurpleLight: "#F7E6F8",
  billingNavy: "#0E0BC7",
  billingNavyLight: "#E6E6F4",
  billingGreen: "#56D586",
  billingGreenLight: "#E8F9EE",
};
